import AddQuantityModalView from "./addQuantityModal.html";


angular.module("materials")

    .controller("MaterialsListCtrl", ['LoginService', '$rootScope', '$scope', '$http', '$interval', '$q', 'i18nService', 'Restangular', 'gridService', '$filter', '$translate', 'modalService', '$uibModal','$state', 'datasetsService',
        function (LoginService, $rootScope, $scope, $http, $interval, $q, i18nService, Restangular, gridService, $filter, $translate, modalService, $uibModal,$state, datasetsService) {

            //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("MATERIAL_WRITE");

        $rootScope.title = $filter('translate')('materials.title');
        $rootScope.breadcrumb = [
            { title: $filter('translate')('materials.title') }
        ];

        $scope.material = {
            is_external: false
        };

        //Al listar, devolvemos todos los materiales que ya se han utilizado y ha finalizado el evento, tiene que estar activo el check retornar automaticamente
        Restangular.all('Materials/AutomaticMovement').post().then(function () {
        });

        $scope.gridOptionsInternalMaterials = {
            pdfTitle: $filter('translate')('materials.pdf_title'),
            exporterMenuCsv: true,
            enableGridMenu: true,
            //gridMenuShowHideColumns: false,
            enableSorting: true,
            paginationPageSizes: [20, 40, 60],
            paginationPageSize: 20,
            rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
            },
            columnDefs: [
              { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
              { name: 'FK_materials_providers.name', displayName: $filter('translate')('materials.provider_name'), enableFiltering: true },
              { name: 'type', field: 'FK_materials_materials_types.name', displayName: $filter('translate')('materials.material_type'), enableFiltering: true },
              { name: 'name', displayName: $filter('translate')('materials.name'), enableFiltering: true, enableHiding: false },
              { name: 'description', displayName: $filter('translate')('materials.description'), enableFiltering: true },
              {
                  name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                      { title: $filter('translate')('materials.button_edit'), action: 'ui-sref="materials.edit({id:row.entity.id , is_external:false})"', cssIconClass: "fa fa-edit" },
                      { title: $filter('translate')('materials.button_delete'), action: 'ng-click="grid.appScope.deleteInternalDialog(row.entity.id,row.entity.name);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                  ], { cssClass: "pull-right" })
              },
            ],
            getData: function (options) {
                options.is_external = false;
                return Restangular.all('Materials').getList(options);
            }
        };

        $scope.goToEdit = function (rowEntity) {
            $state.go("materials.edit", { id: rowEntity.id, is_external: $scope.material.is_external });
        }


        $scope.deleteInternalDialog = function (id, name) {
            $scope.id = id;
            $scope.name = name;
            modalService.confirm({
                title: $filter('translate')('materials.button_delete'),
                message: $filter('translate')('materials.delete_message') + " " + $scope.name + "?",
                onAccept: function () {
                    Restangular.one('Materials', $scope.id).remove().then(function () {
                        toastr.success($filter('translate')('materials.delete_success'));
                        $scope.gridOptionsInternalMaterials.gridApi.core.raise.itemDeleted($scope);
                    }, function (response) {
                        $scope.errorMessage = response.message;
                    });
                }
            });

        };

        $scope.gridOptionsExternalMaterials = {
            pdfTitle: $filter('translate')('materials.pdf_title'),
            exporterMenuCsv: true,
            enableGridMenu: true,
            //gridMenuShowHideColumns: false,
            enableSorting: true,
            paginationPageSizes: [20, 40, 60],
            paginationPageSize: 20,
            rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
            },
            columnDefs: [
              { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
              { name: 'FK_materials_providers.name', displayName: $filter('translate')('materials.provider_name'), enableFiltering: true },
              { name: 'type', field: 'FK_materials_materials_types.name', displayName: $filter('translate')('materials.material_type'), enableFiltering: true },
              { name: 'name', displayName: $filter('translate')('materials.name'), enableFiltering: true, enableHiding: false },
              { name: 'description', displayName: $filter('translate')('materials.description'), enableFiltering: true },
              {
                  name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                      { title: $filter('translate')('materials.button_edit'), action: 'ui-sref="materials.edit({id:row.entity.id , is_external:true})"', cssIconClass: "fa fa-edit" },
                      { title: $filter('translate')('materials.button_delete'), action: 'ng-click="grid.appScope.deleteExternalDialog(row.entity.id,row.entity.name);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                  ], { cssClass: "pull-right" })
              },
            ],
            getData: function (options) {
                options.is_external = true;
                return Restangular.all('Materials').getList(options);
            }
        };


        $scope.deleteExternalDialog = function (id, name) {
            $scope.id = id;
            $scope.name = name;
            modalService.confirm({
                title: $filter('translate')('materials.button_delete'),
                message: $filter('translate')('materials.delete_message') + " " + $scope.name + "?",
                onAccept: function () {
                    Restangular.one('Materials', $scope.id).remove().then(function () {
                        toastr.success($filter('translate')('materials.delete_success'));
                        $scope.gridOptionsExternalMaterials.gridApi.core.raise.itemDeleted($scope);

                    }, function (response) {
                        $scope.errorMessage = response.message;
                    });
                }
            });

        };
        $scope.export = function () {
            var options = {
                filters: {
                    IS_EXTERNAL: $scope.material.is_external
                }
            };

            datasetsService.exportByType("materials", options);
        };

        $scope.gridOptionsMaterialsReturn = {
            pdfTitle: $filter('translate')('materials.pdf_title'),
            exporterMenuCsv: true,
            enableGridMenu: true,
            //gridMenuShowHideColumns: false,
            enableSorting: true,
            paginationPageSizes: [20, 40, 60],
            paginationPageSize: 20,
            rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
            },
            columnDefs: [
                { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                { name: 'type', field: 'FK_events_materials_materials.FK_materials_materials_types.FK_materials_types_tl_materials_types[0].name', displayName: $filter('translate')('materials.material_type'), enableFiltering: true },
                { name: 'name', field: 'FK_events_materials_materials.name', displayName: $filter('translate')('materials.name'), enableFiltering: true, enableHiding: false },
                { name: 'description', field: 'FK_events_materials_materials.description', displayName: $filter('translate')('materials.description'), enableFiltering: true },
                { name: 'quantity', displayName: $filter('translate')('materials.quantity'), enableFiltering: true },
                { name: 'quantity_returned', displayName: $filter('translate')('materials.quantity_returned'), enableFiltering: true },
                {
                    name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                        { title: $filter('translate')('general.button_return'), action: 'ng-click="grid.appScope.returnMaterial({id:row.entity.id})"', cssIconClass: "fa fa-reply" },
                    ], { cssClass: "pull-right" })
                },
            ],
            getData: function (options) {
                return Restangular.all('EventsMaterials/GetEventMaterialReturn').getList({});
            }
        };

            $scope.returnMaterial = function (eventMaterialId) {
                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: AddQuantityModalView,
                    size: "sm",
                    controller: "AddQuantitiesMaterialsReturnModalCtrl",
                    resolve: {
                        eventMaterialId: function () { return eventMaterialId.id }
                    }
                });

                // Response del modal
                $modalInstance.result.then(function (movement) {
                        toastr.success($filter('translate')('materials.edit_success'));
                        $scope.gridOptionsMaterialsReturn.loadData(false);
                }, function () { });
            }
    }])

    .controller("AddQuantitiesMaterialsReturnModalCtrl", ['$scope', '$uibModalInstance', 'Restangular', 'modalService', '$filter', '$http', '$q', 'eventMaterialId', function ($scope, $uibModalInstance, Restangular, modalService, $filter, $http, $q, eventMaterialId) {
        $scope.isMaterialReturn = true;
        var event_material_origin;
        Restangular.one('EventsMaterials', eventMaterialId).get().then(function (result) {
            event_material_origin = angular.copy(result);
            $scope.movement = result;
            if ($scope.movement.quantity_returned != null && $scope.movement.quantity_returned > 0) {
                $scope.movement.quantity = $scope.movement.quantity - $scope.movement.quantity_returned;
                event_material_origin.quantity = $scope.movement.quantity;
            }
            
        });

        $scope.selectWarehouses = [];
        Restangular.all('Warehouses').getList().then(function (warehouses) {
            $scope.selectWarehouses = warehouses;
        });

        $scope.onSave = function () {

            if ($scope.movement.quantity <= event_material_origin.quantity) {
                Restangular.all('Warehouses').customGET("GetTotalStockInWarehouse", { warehouse_id: $scope.movement.warehouse_id, product_id: $scope.movement.material_id, type: "materials" }).then(function (res) {
                    $scope.totalStock = res;
                    //Comprobamos con los numeros negativos que no pongan menos cantidad de la que hay
                    if ($scope.movement.quantity < 0) {
                        if (parseInt($scope.movement.quantity) < $scope.totalStock * -1) {
                            $scope.errorUnits = true;
                        }
                        else
                            $scope.errorUnits = false;
                    }

                    $scope.movement.put().then(function (result) {
                        $uibModalInstance.close(result);
                    })
                });
            }
        }

        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };


    }])
;